/* eslint-disable @typescript-eslint/indent */
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Validators } from "@angular/forms";
import { Observable, of, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { environment } from "../../../../../environments/environment";
import { QuestionBase } from "../../../../shared/components/dynamic-form/question-base";
import { FileQuestion } from "../../../../shared/components/dynamic-form/question-file";
import { TextAreaQuestion } from "../../../../shared/components/dynamic-form/question-textarea";
import { TextboxQuestion } from "../../../../shared/components/dynamic-form/question-textbox";
import { pattern } from "../../../../shared/constants/patterns";
import { ContractAttachment } from "../contract.type";

@Injectable()
export class ContractAttachmentsService {
  basePath = `${environment.serverUrl}/contract-attachments`;
  constructor(private readonly http: HttpClient) {}

  uploadFile(url: string, file: File): Observable<any> {
    return this.http.put<Observable<any>>(url, file).pipe(
      tap(() => console.log()),
      catchError(this.handleError<any>("")),
    );
  }

  generateQuestions(options?: {
    contractAttachment?: ContractAttachment;
    isNameEditable: boolean;
    isDescriptionEditable: boolean;
    hideFile: boolean;
  }): Observable<QuestionBase<string | boolean | number>[]> {
    const questions: QuestionBase<string | boolean | number>[] = [
      new TextboxQuestion({
        value: options.contractAttachment?.name,
        key: "name",
        label: "Name",
        required: options.isNameEditable,
        disabled: !options.isNameEditable,
        order: 1,
        errors: [
          {
            key: "pattern",
            validator: Validators.pattern(pattern.words),
            message: "Name is <strong>not valid</strong>",
          },
          {
            key: "minlength",
            validator: Validators.minLength(2),
            message: "Name is <strong>too short</strong>",
          },
          {
            key: "maxlength",
            validator: Validators.maxLength(200),
            message: "Name is <strong>too long</strong>",
          },
        ],
      }),

      new TextAreaQuestion({
        value: options.contractAttachment?.description,
        key: "description",
        label: "Description",
        required: true,
        disabled: !options.isDescriptionEditable,
        errors: [
          {
            key: "pattern",
            validator: Validators.pattern(pattern.words),
            message: "Notes is <strong>not valid</strong>",
          },
          {
            key: "minlength",
            validator: Validators.minLength(1),
            message: "Notes is <strong>too short</strong>",
          },
          {
            key: "maxlength",
            validator: Validators.maxLength(1000),
            message: "Notes is <strong>too long</strong>",
          },
        ],
        order: 2,
      }),
      new FileQuestion({
        key: "file",
        label: "Attachment",
        required: !options.hideFile,
        hide: options.hideFile,
        order: 3,
      }),
    ];

    return of(questions.filter((field) => field).sort((a, b) => a.order - b.order));
  }

  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<T> => throwError(error);
  }
}
